import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";

// Consent Form Component
function ConsentForm() {
  return (
    <>
      <Form>
        <Container className="px-0" fluid>
          <Row className="no-gutters">
            <Col sm="6">
              <div className="form-wrapper rounded">
                <div className="form-heading mb-4 text-uppercase fw-bold">
                  Consent
                </div>
                <div className="mb-3">
                  By submitting this application through the Building Permit
                  Portal, you, the applicant, hereby agree to the following
                  terms:
                </div>
                <div className="mb-3 fw-bold">1. Accuracy of Information:</div>
                <div className="mb-3">
                  You confirm that all the information provided in the
                  application form is accurate, complete, and up-to-date to the
                  best of your knowledge.
                  <br />
                  You acknowledge that submitting false or misleading
                  information may result in the rejection of your application or
                  future legal action.
                </div>
                <div className="mb-3 fw-bold">2. Document Submission:</div>
                <div className="mb-3">
                  You consent to the submission of all required documents,
                  including but not limited to, architectural plans, licenses,
                  and permits, which are necessary for processing your
                  application.
                  <br />
                  You understand that all submitted documents will be reviewed
                  by the assigned community, and further verification or
                  additional documents may be requested.
                </div>
                <div className="mb-3 fw-bold">3. Communication Consent:</div>
                <div className="mb-3">
                  You consent to receive electronic communications (via email)
                  related to the status of your application, requests for
                  additional documentation, or other matters necessary for the
                  processing of your application.
                  <br />
                  You agree to the inclusion of your application summary in a
                  confirmation email, which may include personal or
                  project-specific information for tracking and transparency
                  purposes.
                </div>
                <div className="mb-3 fw-bold">4. Data Usage and Privacy:</div>
                <div className="mb-3">
                  You agree that the information provided in this application
                  may be shared with authorized community officials and relevant
                  stakeholders for the purpose of reviewing and processing the
                  application.
                  <br />
                  Your personal data will be stored and handled in compliance
                  with applicable data protection laws and will not be shared
                  with third parties beyond those necessary for the application
                  process.
                </div>
              </div>
            </Col>
            <Col sm="6">
              <div className="form-wrapper rounded">
                <div className="form-heading mb-4 text-uppercase fw-bold">
                  Disclaimer
                </div>
                <div className="mb-3 fw-bold">1. No Guarantee of Approval:</div>
                <div className="mb-3">
                  Submission of this application does not guarantee that your
                  permit will be approved. Each application will be reviewed by
                  the appropriate community, and approval is contingent upon
                  meeting all legal, regulatory, and community-specific
                  requirements.
                </div>
                <div className="mb-3 fw-bold">2. Processing Time:</div>
                <div className="mb-3">
                  The processing time for applications may vary depending on the
                  complexity of the project, the completeness of the submitted
                  documents, and the workload of the reviewing community. The
                  Building Permit Portal does not guarantee specific processing
                  times.
                </div>
                <div className="mb-3 fw-bold">3. Document Responsibility:</div>
                <div className="mb-3">
                  The applicant is solely responsible for ensuring that all
                  required documents are submitted in the correct format and
                  contain accurate information. The Building Permit Portal is
                  not liable for errors, omissions, or delays caused by
                  incomplete or inaccurate submissions.
                </div>
                <div className="mb-3 fw-bold">4. Rejection or Revocation:</div>
                <div className="mb-3">
                  The community reserves the right to reject or revoke an
                  application at any stage if it fails to meet the necessary
                  requirements or if discrepancies are found in the submitted
                  documents.
                </div>
                <div className="mb-3 fw-bold">5. Liability:</div>
                <div className="mb-3">
                  The Building Permit Portal and its administrators are not
                  liable for any damages, delays, or losses incurred as a result
                  of using this portal or due to the rejection, revocation, or
                  delay of an application.
                </div>
                <div className="mb-3 fw-bold">6. Responsibility:</div>
                <div className="mb-3">
                  Applicant who performs work as the contractor hereby
                  acknowledges that all work will be in compliance with
                  applicable code requirements and local regulations.
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Form>
    </>
  );
}

export default ConsentForm;
